import AdminForm from "features/admin/AdminForm";
import { FieldsRow } from "features/admin/Products/types";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addInstallation } from "../installationAdminSlice";
const fields: FieldsRow[] = [
  {
    row: [
      {
        title: "Информация",
        data: [
          {
            required: false,
            options: undefined,
            type: "number",
            title: "От (BTU)",
            name: "from_power",
            value: "",
          },
          {
            required: false,
            options: undefined,
            type: "number",
            title: "До (BTU)",
            name: "to_power",
            value: "",
          },
          {
            required: false,
            options: ["Колонен", "Касетъчен", "Таванен"],
            type: "select",
            title: "Тип на климатик",
            name: "airConditionType",
            value: "",
          },
          {
            required: true,
            options: undefined,
            type: "number",
            title: "Цена в лв",
            name: "price",
            value: "",
          },
          {
            required: false,
            options: undefined,
            type: "number",
            title: "Цена (€)",
            name: "price_eur",
            value: "",
            linkedTo: "price",
          },
        ],
      },
    ],
  },
];

const AddInstallation = () => {
  const dispatch = useDispatch();
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();

  const onSubmit = (data: any) => {
    dispatch(
      addInstallation(data, (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      })
    );
    navigate(-1);
  };

  return (
    <AdminForm
      formTitle="Добавяне на монтаж"
      onSubmit={onSubmit}
      product={fields}
      progress={progress}
    />
  );
};

export default AddInstallation;
